export default __webpack_public_path__ + "static/abstract_obsession-adc7828b8bf8a558cae9f460c46ca95d.png";